exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 small[data-v-56a987c4]{margin-top:5px}", ""]);

// exports
